import { render, staticRenderFns } from "./PrintLabelsButton.vue?vue&type=template&id=f3fbce58&scoped=true&"
import script from "./PrintLabelsButton.vue?vue&type=script&lang=js&"
export * from "./PrintLabelsButton.vue?vue&type=script&lang=js&"
import style0 from "./PrintLabelsButton.vue?vue&type=style&index=0&id=f3fbce58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fbce58",
  null
  
)

export default component.exports